import { ComponentTypeEnum } from "./component-types";

export enum TitleImgSizeEnum {
  Small = "small",
  Big = "big",
}

export interface ITitleComponentDefinition {
  type: ComponentTypeEnum.Title;
  data: {
    title: string;
    value?: string;
    description?: string;
    imgUrl?: string;
    imageUrl?: string;
    imgSize?: TitleImgSizeEnum;
    link?: string;
  };
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
function isValidImgSize(imgSize: any) {
  if (typeof imgSize === "undefined") {
    return true;
  }
  if (imgSize === TitleImgSizeEnum.Big || imgSize === TitleImgSizeEnum.Small) {
    return true;
  }
  return false;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isValidTitleDefinition(rawDefinitionData: any): boolean {
  if (!rawDefinitionData) {
    return false;
  }

  const { title, imgSize } = rawDefinitionData;
  return Boolean(title && isValidImgSize(imgSize));
}
